import React from "react";
import {Button, Col, Row, Space} from "antd";
import {
    FacebookOutlined,
    InstagramOutlined,
    TwitterOutlined,
    PhoneOutlined,
    WhatsAppOutlined,
    MailOutlined,
    HomeOutlined
}
from "@ant-design/icons";
import data from "./data";

const Footer : React.FC = () => {
    return (
        <footer id={"contact"} className={"public-footer"}>
            <div className={"public-container"}>
                <Row gutter={[300, 50]}>
                    <Col lg={12} md={12} sm={24} xs={24}>
                       <div className={"section-heading"}>
                           <h2>{data.id.title}</h2>
                           <p>{data.id.subTitle}</p>
                       </div>
                        <div className={"social-media"}>
                            <Space size={"large"}>
                                <a
                                    href={"https://www.facebook.com/etc-cat"}
                                    target={"_blank"}
                                    rel={"noreferrer"}
                                >
                                    <FacebookOutlined />
                                </a>
                                <a
                                    href={"https://www.instagram.com/etc-cat/"}
                                    target={"_blank"}
                                    rel={"noreferrer"}
                                >
                                    <InstagramOutlined />
                                </a>
                                <a
                                    href={"https://www.facebook.com/etc-cat"}
                                    target={"_blank"}
                                    rel={"noreferrer"}
                                >
                                    <TwitterOutlined />
                                </a>
                            </Space>
                        </div>
                    </Col>
                    <Col lg={12} md={12} sm={24} xs={24}>
                        <div className={"contact"}>
                            <div className={"phone"}>
                                <Space size={"middle"}>
                                    <PhoneOutlined />
                                    +62811 4112
                                </Space> <br/>
                                <Space size={"middle"}>
                                    <PhoneOutlined />
                                    +6281 144 7787
                                </Space>
                            </div>
                            <div className={"wa"}>
                                <Space size={"middle"}>
                                    <WhatsAppOutlined />
                                    +6281 144 7787
                                </Space>
                            </div>
                            <div className={"email"}>
                                <Space size={"middle"}>
                                    <MailOutlined />
                                    hello@etc-cat.com
                                </Space>
                            </div>
                            <div className={"address"}>
                                <Space align={"start"} size={"middle"}>
                                    <HomeOutlined />
                                    Jalan Andi Tonro IV No, 1, Makassar BTN Manakarra Blok D No. 10, Mamuju
                                </Space>
                            </div>
                            <div className={"footer-buttons"}>
                                <Space size={"middle"}>
                                    <Button
                                        size={"large"}
                                        ghost={true}
                                        href={"https://goo.gl/maps/V6XJvBNtSW1va8Sa7"}
                                        target={"_blank"}
                                        rel={"noreferrer"}
                                    >
                                        Get Direction
                                    </Button>
                                    <Button
                                        size={"large"}
                                        ghost={true}
                                        href={"tel:+62811447787"}
                                        target={"_blank"}
                                        rel={"noreferrer"}
                                    >
                                        Call Now
                                    </Button>
                                    <Button
                                        size={"large"}
                                        ghost={true}
                                        href={"https://wa.me/62811447787"}
                                        target={"_blank"}
                                        rel={"noreferrer"}
                                    >
                                        Chat
                                    </Button>
                                </Space>
                            </div>
                        </div>
                    </Col>
                </Row>
                <p>Made with love by ETC</p>
            </div>
        </footer>
    )
}

export default Footer;